import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Badge, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";

import { adminPaths } from "admin/paths";
import AdminFormActions from "components/admin/AdminFormActions";
import AdminPageHeader from "components/admin/AdminPageHeader";
import { roleLabel } from "labels/tr";
import { userRoles } from "data/admin/domain";
import { usersRepo } from "data/repositories/usersRepo";
import EmptyState from "components/EmptyState";

const ROLE_COLORS = { admin: "danger", business: "info", agency: "primary", guide: "warning", customer: "secondary" };

export default function AdminUserDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [error, setError] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  void refreshKey;
  const user = usersRepo.getById(id);
  const [role, setRole] = useState(user?.role || "customer");

  React.useEffect(() => {
    setRole(user?.role || "customer");
  }, [user]);

  if (!user) {
    return (
      <>
        <div className="header bg-gradient-dark pb-6 pt-5 pt-md-7" />
        <Container className="mt--6" fluid><EmptyState title="Kullanıcı bulunamadı" /></Container>
      </>
    );
  }

  const onSubmit = (event) => {
    event.preventDefault();
    setError("");
    try {
      usersRepo.update(user.uid, { role });
      navigate(`/admin${adminPaths.admin.users}`, { state: { status: { color: "success", message: "Kullanıcı rolü güncellendi." } } });
    } catch (submitError) {
      setError(submitError?.message || "Rol güncellenemedi.");
    }
  };

  const toggleArchive = () => {
    if (user.deletedAt) usersRepo.restore(user.uid);
    else usersRepo.remove(user.uid);
    setRefreshKey((value) => value + 1);
  };

  return (
    <>
      <AdminPageHeader
        title="Kullanıcı detayı"
        description="İş ortağı ayrı bir veri rolü değildir; iş ortağı arayüzü işletme, acente ve rehber rollerinin operasyonel görünümüdür."
        backAction={() => navigate(`/admin${adminPaths.admin.users}`)}
      />

      <Container className="mt--6" fluid>
        <Row>
          <Col xl="8">
            <Card className="shadow">
              <CardHeader className="border-0"><h3 className="mb-0">Profil</h3></CardHeader>
              <CardBody>
                {error ? <Alert color="danger">{error}</Alert> : null}
                <div className="mb-3"><strong>Kullanıcı kimliği:</strong> {user.uid}</div>
                <div className="mb-3"><strong>Ad:</strong> {user.displayName || "-"}</div>
                <div className="mb-3"><strong>E-posta:</strong> {user.email || "-"}</div>
                <div className="mb-3"><strong>Oluşturulma:</strong> {user.createdAt || "-"}</div>
                <div className="mb-4"><strong>Son giriş:</strong> {user.lastLoginAt || "-"}</div>
                <Form onSubmit={onSubmit}>
                  <FormGroup>
                    <Label>Rol</Label>
                    <Input type="select" value={role} onChange={(event) => setRole(event.target.value)}>
                      {userRoles.map((item) => <option key={item} value={item}>{roleLabel(item)}</option>)}
                    </Input>
                  </FormGroup>
                  <AdminFormActions
                    saving={false}
                    submitLabel="Rolü kaydet"
                    onCancel={() => navigate(`/admin${adminPaths.admin.users}`)}
                    extraActions={
                      <Button color={user.deletedAt ? "success" : "danger"} className="ml-2" type="button" onClick={toggleArchive}>
                        {user.deletedAt ? "Geri al" : "Arşivle"}
                      </Button>
                    }
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow">
              <CardHeader className="border-0"><h3 className="mb-0">Rol durumu</h3></CardHeader>
              <CardBody>
                <Badge color={ROLE_COLORS[user.role] || "secondary"} pill>{roleLabel(user.role)}</Badge>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
